import raw from "../../data/tables/art/packs/raid/grips.json";
import type { GripPack } from "./grip-resolve";

/** Raid fantasy grip SSOT. */
export const raidGripPack = raw as unknown as GripPack;
